import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

interface Props {
  nomeFormulario: string;
}

const FormularioDownloadButton: React.FC<Props> = ({ nomeFormulario }) => {
  const [formId, setFormId] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    api.get('/formularios')
      .then(res => {
        const forms: any[] = res.data.formularios || [];
        const normalizar = (s: string) =>
          s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
        const nomeBuscado = normalizar(nomeFormulario);
        // 1. Tenta match exato (case-insensitive)
        let form = forms.find(f => f.nome.toLowerCase() === nomeFormulario.toLowerCase());
        // 2. Tenta match normalizado (sem acentos e pontuação)
        if (!form) form = forms.find(f => normalizar(f.nome) === nomeBuscado);
        // 3. Tenta match parcial — nome do banco contém o que a IA enviou
        if (!form) form = forms.find(f => normalizar(f.nome).includes(nomeBuscado));
        // 4. Tenta match parcial invertido — o que a IA enviou contém o nome do banco
        if (!form) form = forms.find(f => nomeBuscado.includes(normalizar(f.nome)));
        setFormId(form?.id || null);
      })
      .catch(() => setFormId(null))
      .finally(() => setCarregando(false));
  }, [nomeFormulario]);

  const [baixando, setBaixando] = useState(false);

  const handleDownload = async () => {
    if (!formId || baixando) return;
    setBaixando(true);
    try {
      const res = await api.get(`/formularios/${formId}/download`);
      if (res.data.url) {
        window.open(res.data.url, '_blank');
      }
    } catch {
      toast.error('Erro ao gerar link de download. Tente novamente.');
    } finally {
      setBaixando(false);
    }
  };

  if (carregando) {
    return (
      <span style={{ fontSize: 12, color: '#999', display: 'block', marginTop: 8 }}>
        Carregando formulário...
      </span>
    );
  }

  if (!formId) {
    return (
      <span style={{ fontSize: 12, color: '#e74c3c', display: 'block', marginTop: 8 }}>
        ⚠ Formulário não encontrado. Contate o administrador.
      </span>
    );
  }

  return (
    <button
      onClick={handleDownload}
      disabled={baixando}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        marginTop: 8,
        background: baixando ? '#555' : '#1a1a2e',
        color: '#fff',
        borderRadius: 6,
        padding: '5px 10px',
        fontSize: 12,
        fontWeight: 600,
        border: 'none',
        cursor: baixando ? 'not-allowed' : 'pointer',
        boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
      }}
    >
      {baixando ? '⏳ Gerando link...' : '📥 Baixar formulário'}
    </button>
  );
};

export default FormularioDownloadButton;
